export const generateId = () => `${Date.now()}.${Math.floor(Math.random() * Date.now())}`;

export const setCachedStorageValue = (storage, key, value) => {
    const existingValue = storage.getItem(key);
    if (existingValue) {
        return existingValue;
    }
    storage.setItem(key, value);
    return value;
};

const initDataLayer = () => {
    window.dataLayer = window.dataLayer || [];
};

export const pushEventToDataLayer = (eventName, payload) => {
    initDataLayer();
    window.dataLayer.push({
        ...payload,
        event: eventName
    });
};

export const eventAlreadyLogged = eventName =>
    window.dataLayer && window.dataLayer.length && window.dataLayer.find(item => item.event === eventName);

export const pushUniqueEventToDataLayer = (eventId, payload) => {
    if (!eventAlreadyLogged(eventId)) {
        pushEventToDataLayer(eventId, payload);
    }
};

export const combineStringsWithSpace = strings =>
    strings.reduce((acc, curr) => (curr ? `${acc} ${curr}` : acc), '').trim();
export const getCurrentTimeAsUTC = () => new Date().getTime();
export const getCurrentUrl = () => window.location.href;



// WEBPACK FOOTER //
// ./src/app/services/dataLayer/utils.js